import { useEffect } from 'react';
import useDataProvider, { useQuery } from '@concepta/react-data-provider';
import { toast } from 'react-toastify';

const useGetBraintreeToken = (isEdit: boolean) => {
  const { get } = useDataProvider();

  const getToken = () => {
    return get({
      uri: isEdit ? '/braintree/edit-order' : '/braintree/new-order',
    });
  };

  const { data, execute, isPending, error } = useQuery(getToken, false, {
    onError: error => {
      // Todo: Fix error response in rockets
      const errorRes = error as unknown as {
        response: { data: { message: string } };
      };

      toast.error(errorRes?.response?.data?.message || error?.message);
    },
  });

  // `execute` is re-created every render, so depending on it would refetch in a
  // loop; `isEdit` alone keeps the token in step with the flow.
  useEffect(() => {
    execute();
  }, [isEdit]);

  return { data, execute, isPending, error };
};

export default useGetBraintreeToken;
